module.exports = __webpack_public_path__ + "static/media/liquidgold219400987.99f343c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/liquidgold219400987.png
// module id = 510
// module chunks = 0